import gql from 'graphql-tag';

import path from 'js/lib/path';

import concatName from 'bundles/catalogP/lib/concatName';

export function getLink(instructor: $TSFixMe) {
  return path.join('/', 'instructor', instructor.shortName || '~' + instructor.id);
}
getLink.fragment = gql`
  fragment InstructorsV1_getLink on InstructorsV1 {
    shortName
    id
  }
`;

export function getFullDisplayName(instructor: $TSFixMe) {
  return (
    instructor.fullName ||
    concatName({
      prefix: instructor.prefixName,
      first: instructor.firstName,
      middle: instructor.middleName,
      last: instructor.lastName,
      suffix: instructor.suffixName,
    })
  );
}
getFullDisplayName.fragment = gql`
  fragment InstructorsV1_getFullDisplayName on InstructorsV1 {
    fullName
    prefixName
    firstName
    middleName
    lastName
    suffixName
  }
`;

export function getDisplayName(instructor: $TSFixMe) {
  return concatName({
    first: instructor.firstName,
    last: instructor.lastName,
  });
}
getDisplayName.fragment = gql`
  fragment InstructorsV1_getDisplayName on InstructorsV1 {
    firstName
    lastName
  }
`;

export function shouldDisplay(instructor: $TSFixMe): boolean {
  return !!getFullDisplayName(instructor);
}
shouldDisplay.fragment = gql`
  fragment InstructorsV1_shouldDisplay on InstructorsV1 {
    ...InstructorsV1_getFullDisplayName
  }
  ${getFullDisplayName.fragment}
`;

export function shouldDisplayOnPartnerPage(instructor: $TSFixMe): boolean {
  return shouldDisplay(instructor) && instructor.displayOnPartnerPage;
}
shouldDisplayOnPartnerPage.fragment = gql`
  fragment InstructorsV1_shouldDisplayOnPartnerPage on InstructorsV1 {
    displayOnPartnerPage
    ...InstructorsV1_shouldDisplay
  }
  ${shouldDisplay.fragment}
`;
